import styled from "styled-components";

export const PageWrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(135deg, #f7f8f9 0%, #f0f1f3 100%);
`;

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;


  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;

    &:hover {
      background: #94a3b8;
    }
  }

  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  // padding: 40px 20px;
  min-height: 100%;

  @media (max-width: 768px) {
    padding: 24px 16px;
  }

  @media (max-width: 480px) {
    padding: 16px 12px;
  }
`;

export const FormCard = styled.div`
  width: 100%;
  max-width: 1250px;  /* CHANGED FROM 800px TO 1000px */
  background: #ffffff;
  min-height: 700px; 
  border-radius: 16px;
  padding: 48px;
  
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 768px) {
    padding: 32px 24px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 24px 16px;
    border-radius: 10px;
  }

  /* Ant Design Input Styling */
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-select-selector {
    min-height: 44px !important;
    border: 1.5px solid #e5e7eb !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    transition: all 0.3s ease !important;
    font-size: 14px !important;

    &:hover {
      border-color: #d1d5db !important;
    }

    &:focus,
    &:focus-within {
      border-color: #1b49ea !important;
      box-shadow: 0 0 0 3px rgba(27, 73, 234, 0.1) !important;
    }
  }

  .ant-input {
    padding: 12px 14px !important;
  }

  .ant-select-selector {
    display: flex !important;
    align-items: center !important;
    padding: 0 14px !important;
  }

  textarea.ant-input {
    min-height: auto !important;
    padding: 12px 14px !important;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
      "Ubuntu", "Cantarell", sans-serif;
    resize: vertical;

    &::placeholder {
      color: #9ca3af;
    }
  }

  .ant-btn-primary {
    background: linear-gradient(135deg, #1b49ea 0%, #1339c0 100%);
    border-color: #1b49ea;
    height: 48px;
    border-radius: 8px;
    font-weight: 600;
    padding: 0 32px;
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(135deg, #143ad0 0%, #0f2ea8 100%) !important;
      border-color: #143ad0 !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 16px rgba(27, 73, 234, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: rgb(255, 44, 145);
  letter-spacing: -0.5px;

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const Description = styled.p`
  margin: 12px 0 32px 0;
  color: color: #111827;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.6;
`;

export const FieldWrapper = styled.div`
  margin-bottom: 28px;

  &:last-of-type {
    margin-bottom: 24px;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  letter-spacing: 0.3px;

  span {
    color: #ef4444;
    margin-left: 2px;
  }
`;

export const InputWrapper = styled.div`
    position: relative;
  border: 1.5px solid 
    ${(props) =>
      props.isError ? "#fca5a5" : props.isValid ? "#86efac" : "#e5e7eb"
    };
  border-radius: 8px;
  transition: all 0.3s ease;
  overflow: hidden;

  ${(props) =>
    props.isError &&
    `
    .ant-input,
    .ant-input-affix-wrapper,
    .ant-select-selector,
    textarea.ant-input {
      border-color: transparent !important;
      background: #fff5f5 !important;

      &:focus,
      &:focus-within {
        border-color: transparent !important;
        background: #fff5f5 !important;
        box-shadow: 0 0 0 3px rgba(244, 63, 94, 0.1) !important;
      }
    }
  `}

  ${(props) =>
    props.isValid &&
    `
    .ant-input,
    .ant-input-affix-wrapper,
    .ant-select-selector,
    textarea.ant-input {
      border-color: transparent !important;
      background: #f0fdf4 !important;

      &:focus,
      &:focus-within {
        border-color: transparent !important;
        background: #f0fdf4 !important;
        box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1) !important;
      }
    }
  `}

  .ant-input,
  .ant-input-affix-wrapper,
  .ant-select-selector,
  textarea.ant-input {
    border-color: transparent !important;
  }
`;

export const ErrorMessage = styled.div`
  color: #dc2626;
  font-size: 12px;
  margin-top: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  animation: slideDown 0.2s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ErrorSummary = styled.div`
  background: #fef2f2;
  border: 1.5px solid #fecaca;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 24px;
  animation: slideDown 0.3s ease;

  p {
    color: #991b1b;
    font-weight: 700;
    font-size: 13px;
    margin: 0 0 8px 0;
  }

  ul {
    margin: 0;
    padding-left: 20px;

    li {
      color: #7f1d1d;
      font-size: 13px;
      margin-bottom: 4px;
      list-style: disc;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const QuestionsSection = styled.div`
  margin-bottom: 28px;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`;

export const AddQuestionBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    font-size: 14px;
  }
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 12px;
`;

export const QuestionBlock = styled.div`
  background: #f9fafb;
  border: 1.5px solid ${(props) => (props.isError ? "#fca5a5" : "#e5e7eb")};
  border-radius: 10px;
  padding: 18px;
  transition: all 0.3s ease;
  animation: slideInUp 0.3s ease;

  &:hover {
    background: #f3f4f6;
    border-color: ${(props) => (props.isError ? "#fca5a5" : "#d1d5db")};
  }

  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 480px) {
    padding: 14px;
  }
`;

export const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const QuestionLabel = styled.div`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: rgb(255, 44, 145); 
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const RemoveQuestionBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1.5px solid #ef4444;
  background: #fef2f2;
  color: #dc2626;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;

  &:hover {
    background: #dc2626;
    color: white;
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const QuestionInputWrapper = styled(InputWrapper)`
  ${(props) =>
    props.isError &&
    `
    border-color: #fca5a5 !important;
    background: #fff5f5 !important;

    textarea.ant-input {
      background: #fff5f5 !important;
    }
  `}
`;

export const ButtonWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  @media (max-width: 480px) {
    margin-top: 32px;
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const HalfField = styled.div`
  flex: 1;
`;

/* =========================================================
   NEW: YES/NO Debrief Decision Flow - styled components
   Appended only. Nothing above this line was modified.
   ========================================================= */

export const DecisionCard = styled.div`
  width: 100%;
  max-width: 560px;
  background: #ffffff;
  border-radius: 16px;
  padding: 48px;
  text-align: center;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 480px) {
    padding: 24px 16px;
    border-radius: 10px;
  }
`;

export const DecisionButtonWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
  gap: 16px;

  @media (max-width: 480px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;